const $ = jQuery.noConflict();

const pageScroll = () => {
	// Cache DOM
	const $window = $(window);
	const sections = $('.section');
	const scrollButtons = $('.scroll-section-btn');
	let isOn = false;

	// Functions
	function firePageScroll() {
		if (sections.length > 1) {
			if ($window.width() > 1280) {
				$.scrollify.update();
				if (!isOn) {
					isOn = true;

					$.scrollify({
						section: '.section',
						setHeights: false,
						updateHash: false,
						easing: 'swing',
						scrollSpeed: 600,
						before: () => {
							scrollButtons.attr('disabled', true);
						},
						after: () => {
							scrollButtons.attr('disabled', false);
						},
					});
				}
			} else {
				if (isOn) {
					isOn = false;
					$.scrollify.destroy();
				}
			}
		}
	}

	// Bind Events
	window.addEventListener('resize', () => {
		firePageScroll();
	});

	firePageScroll();
};

export default pageScroll;
